module.exports = __webpack_public_path__ + "static/media/11.af9f8174.png";